import { z } from "zod";

/** Errors any oRPC procedure may raise. Declared once so clients can narrow on `code`. */
export const apiErrors = {
  UNAUTHORIZED: { message: "Sign in required" },
  PROTOCOL_VERSION_UNSUPPORTED: {
    message: "Update required",
    data: z.object({ supported: z.array(z.number().int()) }),
  },
  VALIDATION: { message: "Invalid input" },
  NOT_FOUND: { message: "Not found" },
  DICTATION_UNAVAILABLE: { message: "Dictation is not configured" },
  INTERNAL: { message: "Internal error" },
} as const;

export type ApiErrorCode = keyof typeof apiErrors;
